import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-method-shipment',
  templateUrl: './method-shipment.component.html',
  styleUrls: [
    './method-shipment.component.scss',
    `./styles/method-shipment.${env.template_id}.component.scss`,
  ],
  standalone: true,
  imports: [CommonModule],
})
export class MethodShipmentComponent {
  constructor(public globalService: GlobalService) {}
}
